<div class="application-verification-page">
  <div class="content-wrapper">
    <!-- Page Header -->
    <div class="page-header">
      <h2>KYC Identity Verification</h2>
      <p class="subtitle">Manage verification for all individuals in this application</p>
      </div>

    <!-- Alerts and Messages -->
    @for (alert of alerts; track alert) {
    <message-box title="Error" type="danger">{{ alert }}</message-box>
    }

    <!-- Loading State -->
    @if (isLoading && !applicationData) {
    <div class="loading-section">
      <mat-spinner></mat-spinner>
      <p>Loading verification information...</p>
    </div>
    }

    <!-- Main Content -->
    @if (applicationData) {
    <!-- Application Info Card -->
    <div class="info-card">
      <div class="info-details">
        <div class="info-content">
          <span class="info-label">APPLICATION ID</span>
          <span class="info-value">{{ applicationData.brokerAppId }}</span>
        </div>
        @if (getCompanyName()) {
        <div class="info-content company">
          <span class="info-label">COMPANY</span>
          <span class="info-value">{{ getCompanyName() }}</span>
        </div>
        }
        </div>
        <button mat-stroked-button (click)="refresh()" [disabled]="isLoading" class="refresh-btn">
          <span class="btn-content">
            @if (isLoading) {
            <mat-spinner diameter="16"></mat-spinner>
            <span>Refreshing...</span>
            } @else {
            <span class="mdi mdi-refresh"></span>
            <span>Refresh</span>
            }
          </span>
        </button>
        </div>

    <!-- Individuals Section -->
    @if (applicationData.individuals && applicationData.individuals.length > 0) {
    <div class="individuals-section">
      <div class="section-header">
        <span class="section-title">Individuals</span>
        <span class="section-count">{{ applicationData.individuals.length }}</span>
      </div>
<div class="individuals-table">
  <div class="table-header">
    <div class="col-name">Name</div>
    <div class="col-mobile">Mobile</div>
    <div class="col-status">Status</div>
    <div class="col-date">Updated</div>
    <div class="col-action">Action</div>
  </div>

        @for (individual of applicationData.individuals; track individual.individualId) {
        <div class="table-row">
          <div class="col-name">{{ getRecipientName(individual) }}</div>
          <div class="col-mobile">{{ getMaskedMobile(individual) }}</div>
          <div class="col-status">
            <span class="status-badge" [attr.data-status]="getStatusState(individual.status)">
              {{ getVerificationStatusDisplay(individual.status) }}
            </span>
          </div>
          <div class="col-date">{{ individual.lastUpdate | date: 'dd MMM yyyy' }}</div>
          <div class="col-action">
            @if (canSendSms(individual)) {
            @if (individual.status === 'SMS_SENT') {
            <button mat-stroked-button color="primary" (click)="sendVerificationSms(individual)"
              [disabled]="sendingIndividualId === individual.individualId" class="resend-btn">
              @if (sendingIndividualId === individual.individualId) {
              <mat-spinner diameter="16"></mat-spinner>
              } @else {
              Resend SMS
              }
              </button>
              } @else {
            <button mat-flat-button color="primary" (click)="sendVerificationSms(individual)"
              [disabled]="sendingIndividualId === individual.individualId">
              @if (sendingIndividualId === individual.individualId) {
              <mat-spinner diameter="16"></mat-spinner>
              } @else {
              Send SMS
              }
            </button>
            }
            } @else {
            <span class="verified-text">
              <span class="mdi mdi-check-circle"></span> Verified
            </span>
            }
          </div>
        </div>
        }
        </div>
    </div>
    } @else {
    <div class="empty-state">
      <p>No individuals requiring verification for this application</p>
      </div>
      }
    }
  </div>
</div>